// icons
import emailIcon from '@iconify/icons-carbon/email';
import locationIcon from '@iconify/icons-carbon/location';
import mapIcon from '@iconify/icons-carbon/location-current';
import mobileIcon from '@iconify/icons-carbon/mobile';
import { Container, Divider, Grid, Link, Stack, Tooltip, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import staticLoader from '@utils/staticLoader';
// next
import NextImage from 'next/image';
// components
import {
  BgOverlay,
  FabButtonAnimate,
  Iconify,
  SocialsButton,
  TextIconLabel,
} from '../../components';

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  backgroundColor: theme.palette.background.neutral,
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(10, 0),
  },
}));

// ----------------------------------------------------------------------

export default function ContactInfo() {
  return (
    <RootStyle>
      <Container>
        <Grid
          container
          spacing={3}
          justifyContent={{ md: 'space-between' }}
          alignItems={{ md: 'center' }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                mb: 5,
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              Kontakt oss
            </Typography>

            <Stack spacing={3} alignItems={{ xs: 'center', md: 'flex-start' }}>
              <Stack spacing={{ xs: 2, md: 1 }} direction={{ xs: 'row', md: 'column' }}>
                <TextIconLabel
                  icon={<Iconify icon={emailIcon} sx={{ mr: 1, width: 24, height: 24 }} />}
                  value="Email"
                  sx={{ typography: 'subtitle2' }}
                />
                <Link color="inherit" variant="body2" href="mailto:firmapost@b-e-a.no">
                  firmapost@b-e-a.no
                </Link>
              </Stack>

              <Stack spacing={{ xs: 2, md: 1 }} direction={{ xs: 'row', md: 'column' }}>
                <TextIconLabel
                  icon={<Iconify icon={mobileIcon} sx={{ mr: 1, width: 24, height: 24 }} />}
                  value="Telefon"
                  sx={{ typography: 'subtitle2' }}
                />
                <Link color="inherit" variant="body2" href="tel:55913319">
                  55 91 33 19
                </Link>
              </Stack>

              <Stack spacing={{ xs: 2, md: 1 }} direction={{ xs: 'row', md: 'column' }}>
                <TextIconLabel
                  icon={<Iconify icon={locationIcon} sx={{ mr: 1, width: 24, height: 24 }} />}
                  value="Adresse"
                  sx={{ typography: 'subtitle2' }}
                />
                <Typography variant="body2">Nedre Nøttveit 62, 5238 Rådal</Typography>
              </Stack>

              <Divider sx={{ borderStyle: 'dashed', width: 1 }} />

              <Stack spacing={1} alignItems={{ xs: 'center', md: 'flex-start' }}>
                <Typography variant="overline">Følg oss</Typography>
                <SocialsButton sx={{ color: 'text.primary' }} />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6} lg={7}>
            <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', maxHeight: 400 }}>
              <Tooltip title="Åpne lokasjon i Google Maps" placement="right" followCursor>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.google.com/maps/place/Bergen+Elektro+Automasjon+AS/@60.2963938,5.3417307,15z/data=!4m5!3m4!1s0x0:0xa0254ac335ab8f26!8m2!3d60.2962449!4d5.3450352"
                >
                  <FabButtonAnimate
                    size="large"
                    color="inherit"
                    sx={{ width: 1, height: 1, bgcolor: 'common.white' }}
                    sxWrap={{
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      width: 64,
                      height: 64,
                      zIndex: 9,
                      m: 'auto',
                      position: 'absolute',
                    }}
                  >
                    <Iconify icon={mapIcon} sx={{ color: 'primary.main' }} />
                  </FabButtonAnimate>
                </a>
              </Tooltip>

              <BgOverlay sx={{ opacity: 0.4, borderRadius: 2 }} />

              <NextImage
                objectFit="cover"
                loader={staticLoader}
                layout="responsive"
                height="100%"
                width="100%"
                alt="map thumbnail"
                src="/static/images/map.png"
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
